export default "/images/vendor/flag-icon-css/flags/1x1/gb.svg?35dbacd736781608964ae37a3b390b48";